import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Image, Button } from 'react-bootstrap'

import Breadcrumbs from './../block/Breadcrumbs'
import ConsultationForm from './../block/ConsultationFormF'
import MemoizedHTML from './../block/MemoizedHTML'
import TestimonialsSection from './../block/TestimonialsSection'
import FAQSection from './../block/FAQSection'

import styles from './../style/Kontakti.module.scss';

export default class Kontakti extends Component {

  constructor(props) {
    super(props)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {

    const { data, ajax_data, user_profile_type } = this.props

    const worktime = 'worktime' in data?.page_data ? data?.page_data?.worktime : { one: '', two: '', opt: '' };

    if(user_profile_type == `legal`) return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <div className={styles.section}>
          <Container className={styles.container}>
            <h1>{ajax_data?.pagetitle || ''}</h1>
            <div className={styles.contentblok}>
              <div className={styles.contacti}>
                <div className={styles.phones}>
                  <div>
                    <div className={styles.phone}>{ajax_data?.phones2[0]?.phone || ''}</div>
                    <div className={styles.phone_text}>{ajax_data?.phones2[0]?.name || ''}</div>
                  </div>
                  <div>
                    <div className={styles.phone}>{ajax_data?.phones2[1]?.phone || ''}</div>
                    <div className={styles.phone_text}>{ajax_data?.phones2[1]?.name || ''}</div>
                  </div>
                </div>
                <div className={styles.white_block}>
                  <div className={styles.white_block_pading}>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className={styles.white_block_el}>
                        <Image 
                          src="/images/icons/clock.svg" 
                          alt="Часы работы" 
                          width="22" 
                          height="22" 
                        />
                        <div>
                          <div className={styles.white_block_el_title}>{worktime?.one} {worktime?.opt}</div>
                          <div className={styles.white_block_el_text}>CБ-ВС выходной</div>
                        </div>
                      </div>
                      <Button className={styles.white_block_el_btn + ` text-white`} href={ajax_data?.marshrut} target="_blank" rel="noopener noreferrer" variant="primary">Маршрут</Button>
                    </div>
                    <div className={styles.white_block_el}>
                      <Image 
                        src="/images/icons/map-pin.svg" 
                        alt="Адрес" 
                        width="22" 
                        height="22" 
                      />
                      <div>
                        <div className={styles.white_block_el_title}>г. Нижний Новгород ул. Белинского, 32</div>
                        <div className={styles.white_block_el_text}>Адрес магазина</div>
                      </div>
                    </div>
                    <div className={styles.white_block_el}>
                      <Image 
                        src="/images/icons/mail-red.svg" 
                        alt="Email" 
                        width="22" 
                        height="22" 
                      />
                      <div>
                        <div className={styles.white_block_el_title}>Для оптовой покупки</div>
                        <div className={styles.white_block_el_text}>{data?.page_data?.onsitemailopt || ``}</div>
                      </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <a href={user_profile_type == `legal` ? '/assets/rekviziti_ul.pdf' : '/assets/rekviziti2.pdf'} target="_blank" rel="noopener noreferrer" className={styles.white_block_rekviziti}>
                        <div>Реквизиты компании</div>
                        <Image 
                          src="/images/icons/chevron-down.svg" 
                          alt="Раскрыть" 
                          width="11" 
                          height="6" 
                        />
                      </a>
                      <div className={styles.white_block_svaz + ' d-none d-md-flex'}>
                        <div className='me-1'>Связаться в</div>
                        {/* TG */}
                        {'tglink' in data?.page_data &&
                          <a href={data?.page_data.tglink} target="_blank" rel="noopener noreferrer">
                            <Image alt="TG" src={data?.page_data?.tgicon || ''} width="20" height="20" />
                          </a>
                        }
                        {/* WA */}
                        {'walink' in data?.page_data &&
                          <a href={data?.page_data.walink} target="_blank" rel="noopener noreferrer">
                            <Image alt="WA" src={data?.page_data?.waicon || ''} width="20" height="20" />
                          </a>
                        }
                      </div>
                      <div style={{ gap: `7px` }} className={'d-flex d-md-none'}>
                        {/* TG */}
                        {'tglink' in data?.page_data &&
                          <a href={data?.page_data.tglink} target="_blank" rel="noopener noreferrer">
                            <Image alt="TG" src={data?.page_data?.tgicon || ''} width="38" height="38" />
                          </a>
                        }
                        {/* WA */}
                        {'walink' in data?.page_data &&
                          <a href={data?.page_data.walink} target="_blank" rel="noopener noreferrer">
                            <Image alt="WA" src={data?.page_data?.waicon || ''} width="38" height="38" />
                          </a>
                        }
                      </div>
                    </div>
                  </div>
                  <ConsultationForm />
                </div>
              </div>
              <div className={styles.map}>
                <div className={styles.map_el}><MemoizedHTML html={ajax_data?.yandexmap3 || ''} /></div>
              </div>
            </div>
          </Container>
        </div>
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <div className={styles.section}>
          <Container className={styles.container}>
            <h1>{ajax_data?.pagetitle || ''}</h1>
            <div className={styles.contentblok}>
              <div className={styles.contacti}>
                <div className={styles.phones}>
                  <div>
                    <div className={styles.phone}>{ajax_data?.phones1[0]?.phone || ''}</div>
                    <div className={styles.phone_text}>{ajax_data?.phones1[0]?.name || ''}</div>
                  </div>
                  <div>
                    <div className={styles.phone}>{ajax_data?.phones1[1]?.phone || ''}</div>
                    <div className={styles.phone_text}>{ajax_data?.phones1[1]?.name || ''}</div>
                  </div>
                </div>
                <div className={styles.phones}>
                  <div>
                    <Button className={styles.white_block_el_btn_w210 + ` text-white`} href={ajax_data?.marshrut} target="_blank" rel="noopener noreferrer" variant="primary">Маршрут</Button>
                  </div>
                  <div>
                    <div className={styles.phone}>{ajax_data?.phones1[2]?.phone || ''}</div>
                    <div className={styles.phone_text}>{ajax_data?.phones1[2]?.name || ''}</div>
                  </div>
                </div>
                <div className={styles.white_block}>
                  <div className={styles.white_block_pading}>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className={styles.white_block_el}>
                        <Image 
                          src="/images/icons/clock.svg" 
                          alt="Часы работы" 
                          width="22" 
                          height="22" 
                        />
                        <div>
                          <div className={styles.white_block_el_title}>{worktime?.one} {worktime?.two}</div>
                          <div className={styles.white_block_el_text}>CБ-ВС выходной</div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.white_block_el}>
                      <Image 
                        src="/images/icons/map-pin.svg" 
                        alt="Адрес" 
                        width="22" 
                        height="22" 
                      />
                      <div>
                        <div className={styles.white_block_el_title}>г. Нижний Новгород ул. Белинского, 32</div>
                        <div className={styles.white_block_el_text}>Адрес магазина</div>
                      </div>
                    </div>
                    <div className={styles.white_block_el}>
                      <Image 
                        src="/images/icons/map-pin.svg" 
                        alt="Адрес" 
                        width="22" 
                        height="22" 
                      />
                      <div>
                        <div className={styles.white_block_el_title}>г. Арзамас, ул. Володарского, 128</div>
                        <div className={styles.white_block_el_text}>Адрес магазина</div>
                      </div>
                    </div>
                    <div className={styles.white_block_el}>
                      <Image 
                        src="/images/icons/mail-red.svg" 
                        alt="Email" 
                        width="22" 
                        height="22" 
                      />
                      <div>
                        <div className={styles.white_block_el_title}>Для розничной покупки</div>
                        <div className={styles.white_block_el_text}>{data?.page_data?.onsitemail || ``}</div>
                      </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <a href={user_profile_type == `legal` ? '/assets/rekviziti_ul.pdf' : '/assets/rekviziti2.pdf'} target="_blank" rel="noopener noreferrer" className={styles.white_block_rekviziti}>
                        <div>Реквизиты компании</div>
                        <Image 
                          src="/images/icons/chevron-down.svg" 
                          alt="Раскрыть" 
                          width="11" 
                          height="6" 
                        />
                      </a>
                      <div className={styles.white_block_svaz + ' d-none d-md-flex'}>
                        <div className='me-1'>Связаться в</div>
                        {/* TG */}
                        {'tglink' in data?.page_data &&
                          <a href={data?.page_data.tglink} target="_blank" rel="noopener noreferrer">
                            <Image alt="TG" src={data?.page_data?.tgicon || ''} width="20" height="20" />
                          </a>
                        }
                        {/* WA */}
                        {'walink' in data?.page_data &&
                          <a href={data?.page_data.walink} target="_blank" rel="noopener noreferrer">
                            <Image alt="WA" src={data?.page_data?.waicon || ''} width="20" height="20" />
                          </a>
                        }
                      </div>
                      <div style={{ gap: `7px` }} className={'d-flex d-md-none'}>
                        {/* TG */}
                        {'tglink' in data?.page_data &&
                          <a href={data?.page_data.tglink} target="_blank" rel="noopener noreferrer">
                            <Image alt="TG" src={data?.page_data?.tgicon || ''} width="38" height="38" />
                          </a>
                        }
                        {/* WA */}
                        {'walink' in data?.page_data &&
                          <a href={data?.page_data.walink} target="_blank" rel="noopener noreferrer">
                            <Image alt="WA" src={data?.page_data?.waicon || ''} width="38" height="38" />
                          </a>
                        }
                      </div>
                    </div>
                  </div>
                  <ConsultationForm />
                </div>
              </div>
              <div className={styles.map}>
                <div className={styles.map_el}><MemoizedHTML style={{ width: `100%` }} html={ajax_data?.yandexmap || ''} /></div>
                <div className={styles.map_el}><MemoizedHTML style={{ width: `100%` }} html={ajax_data?.yandexmap2 || ''} /></div>
              </div>
            </div>
          </Container>
        </div>
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Kontakti.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}